import { requestStatus } from "../../../constants";

export const getApprovalStatusText = (status: any, isDemand: boolean = false): string => {
    if (status === requestStatus.submitted || status === requestStatus.preApproved) {
      return "Đang đợi duyệt";
    } else if (status === requestStatus.approved) {
      return "Đã duyệt";
    } else if ([requestStatus.inProgress, "InProgress"].includes(status)) {
      return isDemand ? "Đang tiếp nhận" : "Đang thực hiện";
    } else if (status === requestStatus.acceptance) {
      return isDemand ? "Đã tiếp nhận" : "Tiến hành nghiệm thu";
    } else if (status === requestStatus.completed) {
      return isDemand ? "Tiến hành thực hiện" : "Đã hoàn tất";
    } else if (status === requestStatus.rejected) {
      return "Đã bị từ chối";
    }
  
    return status;
  };